import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class RoomtypeService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('roomtype/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('roomtype/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('roomtype/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('roomtype/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('roomtype/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('roomtype/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('roomtype/delete', val_id);
  }
}
